export default __webpack_public_path__ + "static/SSSpyView_screenshot-3@mob-269f01242177c72da77cb46d7f711a3f.jpg";